import ActionText from '../ActionText';
import Tooltip from '@material-ui/core/Tooltip';
import SaveAltIcon from '@material-ui/icons/SaveAlt';
import { Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import { globalStyles as styles } from '../style/gstheme';
import { withStyles } from '@material-ui/core/styles';
import React, { Component } from 'react';
import PagingFilter from '../PagingFilter';
import Errored from '../Errored';
import Loading from '../Loading';
import SnapshotConfigurationCard from './SnapshotConfigurationCard';
import { getGraphFromProject } from '../utils/utils';

class SnapshotConfigurationStructure extends Component {

  constructor(props) {
    super(props);
    this.state = {
      text: ""
    };
  }

  filterLabel = (event) => this.setState({ text: event.target.value });

  handleFilterChange = (text) => {
    this.props.onUpdate(text);
    this.setState({ text: text.trim() });
  };

  render() {

    const { isLoading, isErrored, text } = this.state;
    const { onSelectConfiguration, classes, selectedConfiguration, configurations, displayConfigurations, maxConfigurations } = this.props;

    if (isErrored) return <Errored data={isErrored} />;
    if (isLoading) return <Loading />;

    return (
      <div className={classes.controlPanel}>
        <Tooltip title="Number of snapshots configured against maximum number permitted">
          <Typography data-test="snapshot-count" variant="body2" style={{ marginTop: 6 }}><SaveAltIcon style={{ verticalAlign: 'middle', transform: 'translateY(-1px)' }} />&#160;{configurations.length}/{maxConfigurations}</Typography>
        </Tooltip>
        <div>
          <div style={{ marginTop: '10px', backgroundColor: '#ffffff', minHeight: 46 }}>
            {configurations.length > 0 && <PagingFilter
              handleFilterChange={this.handleFilterChange}
              placeholder="Enter part of a project title"
              text={text}
              maxLength={100} />
            }
          </div>
          <div data-test="configuration-list-container" className={classes.tree} style={{ top: '180px' }}>
            {configurations.length === 0 ?
              <ActionText offset="70px">No projects.</ActionText>
              :
              <div data-test="configurations-list">
                {displayConfigurations.map(configuration => <SnapshotConfigurationCard
                  isSelected={selectedConfiguration === configuration.id}
                  handleNotAvailable={true}
                  key={configuration.id}
                  configuration={configuration}
                  graph={getGraphFromProject(configuration.project)}
                  id={configuration.project}
                  onSelectConfiguration={onSelectConfiguration} />)
                }
              </div>
            }
          </div>
        </div>
      </div>
    );
  }
}

SnapshotConfigurationStructure.defaultProps = {
  maxConfigurations: 5
};

SnapshotConfigurationStructure.propTypes = {
  classes: PropTypes.object,
  configurations: PropTypes.array.isRequired,
  displayConfigurations: PropTypes.array.isRequired,
  maxConfigurations: PropTypes.number,
  onUpdate: PropTypes.func.isRequired,
  selectedConfiguration: PropTypes.string,
  onSelectConfiguration: PropTypes.func.isRequired
};

export default withStyles(styles)(SnapshotConfigurationStructure);